import Vue from 'vue'
import Vuex from 'vuex'

import AuthModule, { AuthState } from '../domains/auth/auth.store'
import ConfigStore, { ConfigState } from '@/domains/global/config.store'
import LanguageModule, { LanguageState } from '@/domains/languages/languages.store'
import CountryModule from '@/domains/countries/countries.store'

export type RootState = {
  successMessage: string | null,
  success: { showing: boolean },
  errorMessage: string | null,
  error: { showing: boolean },
  messageMessage: string | null,
  message: { showing: boolean },
  showIntroVideo: boolean,
  showProviderIntroVideo: boolean,
  acceptedTerms: boolean;

  auth?: AuthState;
  config?: ConfigState;
  languages?: LanguageState;
}

Vue.use(Vuex)

export default new Vuex.Store<RootState>({
  state: () => ({
    successMessage: null,
    success: { showing: false },
    errorMessage: null,
    error: { showing: false },
    messageMessage: null,
    message: { showing: false },
    showIntroVideo: false,
    showProviderIntroVideo: false,
    acceptedTerms: false
  }),
  mutations: {
    SET_SUCCESS(state, newData) {
      state.successMessage = newData.message
      state.success.showing = true
    },
    HIDE_SUCCESS(state) {
      state.success.showing = false
    },
    SET_ERROR(state, newData) {
      state.errorMessage = newData.message
      state.error.showing = true
    },
    HIDE_ERROR(state) {
      state.error.showing = false
    },
    SET_MESSAGE(state, newData) {
      state.messageMessage = newData.message
      state.message.showing = true
    },
    HIDE_MESSAGE(state) {
      state.message.showing = false
    },
    SET_SHOW_INTRO(state, data) {
      state.showIntroVideo = data
    },
    SET_ACCEPTED_TERMS(state, data) {
      state.acceptedTerms = data
    }
  },
  actions: {
    success({ commit }, message) {
      commit('SET_SUCCESS', { message })
      return true
    },
    error({ commit }, message) {
      commit('SET_ERROR', { message })
      return true
    },
    message({ commit }, message) {
      commit('SET_MESSAGE', { message })
      return true
    },
    setShowIntroVideo({ commit }, show) {
      commit('SET_SHOW_INTRO', show)
      return show
    }
  },
  modules: {
    auth: AuthModule,
    config: ConfigStore,
    languages: LanguageModule,
    countries: CountryModule
  }
})
